var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('v-alert',{staticStyle:{"width":"100%"},attrs:{"type":"error","outlined":""}},[_vm._v(" Invalid request: "+_vm._s(_vm.formattedErrorMesssage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }